import { ImportantDate } from "@king-ict/eupisi-ui/models";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { 
  getCurrentImportantDate,
  getCurrentPedagogicalYear,
  getUserSession,
  getUserAuthData as getUserAuthDataApi,
  getInstitutionDetails as getInstitutionDetailApi,
} from "../api";
import {PedagogicalYear, User, UserAuthData, userInitial, InstitutionDetailsData, institutionDetailsInitialData} from "../models";

interface ApplicationState {
  user: User;
  userAuthData: UserAuthData[] | undefined;
  importantDate: ImportantDate;
  pedagogicalYear: PedagogicalYear;
  institutionDetails: InstitutionDetailsData;
}

const initialState: ApplicationState = {
  user: userInitial,
  userAuthData: undefined,
  importantDate: {} as ImportantDate,
  pedagogicalYear: {} as PedagogicalYear,
  institutionDetails: institutionDetailsInitialData,
};

export const getUser = createAsyncThunk(
  "application/getUser", 
  async () => {
  const user = await getUserSession();
  return user;
});

export const getUserAuthData = createAsyncThunk(
  "application/getUserAuthData",
  async () => {
    const authData = await getUserAuthDataApi();
    return authData;
  }
);

export const getImportantDate = createAsyncThunk(
  "application/getImportantDate",
  async () => {
    const importantDate = await getCurrentImportantDate();
    return importantDate;
  }
);

export const getPedagogicalYear = createAsyncThunk(
  "application/getPedagogicalYear",
  async () => {
    const year = await getCurrentPedagogicalYear();
    return year;
  }
);

export const getInstitutionDetails = createAsyncThunk(
  "application/getInstitutionDetails", 
  async () => {
  const institutionDetails = await getInstitutionDetailApi();
  return institutionDetails;
});

const applicationSlice = createSlice({
  name: "application",
  initialState: initialState,
  reducers: {
    updateUserAuthorization(state, action: PayloadAction<UserAuthData>) {
      state.user.roleId = action.payload.roleId;
      state.user.institutionId = action.payload.institutionId;
      state.user.enrollmentGroupId = action.payload.enrollmentGroupId;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUser.fulfilled, (state, { payload }) => {
        state.user = payload;
      })
      .addCase(getUserAuthData.fulfilled, (state, action) => {
        state.userAuthData = action.payload;
      })
      .addCase(getImportantDate.fulfilled, (state, { payload }) => {
        state.importantDate = payload;
      })
      .addCase(getPedagogicalYear.fulfilled, (state, { payload }) => {
        state.pedagogicalYear = payload;
      })
      .addCase(getInstitutionDetails.fulfilled, (state, { payload }) => {
        state.institutionDetails = payload;
      });
  },
});

export const { updateUserAuthorization } = applicationSlice.actions;

export default applicationSlice.reducer;
